import { render, staticRenderFns } from "./Gmapswap.vue?vue&type=template&id=949fbc38&scoped=true&"
import script from "./Gmapswap.vue?vue&type=script&lang=js&"
export * from "./Gmapswap.vue?vue&type=script&lang=js&"
import style0 from "./Gmapswap.vue?vue&type=style&index=0&id=949fbc38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949fbc38",
  null
  
)

export default component.exports